<script lang="ts">
    import { slide } from "svelte/transition";
    import { menu, adminMenu, MENU_TYPES } from "./menu.lib";
    import Icon from "svelte-fa";
    import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
    import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
    import { trackNavigationClickTypes, trackNavigationClick } from "$utils/track.utils.js";

    export let open = false;
    export let menuType: "user" | "admin" = "user";

    const menuTypeMap = {
        admin: adminMenu,
        user: menu,
    };

    let selectedMenuItemString: string | null = "1-0";
    const toggleMenu = (selectionString: string) => {
        if (selectedMenuItemString === selectionString) {
            selectedMenuItemString = null;
            return;
        }
        selectedMenuItemString = selectionString;
    };
    const closeMenu = () => (open = false);
</script>

<aside class:open>
    <div class="scroller">
        <nav>
            <ul>
                {#each menuTypeMap[menuType] as section, menuIndex}
                    {#each section as topLevelItem, sectionIndex}
                        <!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-element-interactions -->
                        <li
                            class:selected={selectedMenuItemString === `${menuIndex}-${sectionIndex}`}
                            class:section-end={sectionIndex === section.length - 1 && menuIndex !== menu.length - 1}
                            class:submenu={topLevelItem.type === MENU_TYPES.SUBMENU}
                            aria-label={topLevelItem.name}
                            on:click={() =>
                                topLevelItem.type === MENU_TYPES.SUBMENU && toggleMenu(`${menuIndex}-${sectionIndex}`)}
                            class="toplevel-item"
                        >
                            <div>
                                {#if topLevelItem.type === MENU_TYPES.LINK}
                                    <a
                                        style="font-size:13px;"
                                        on:click={() => {
                                            closeMenu();
                                            trackNavigationClick(
                                                trackNavigationClickTypes.MOBILE_MENU_CLICK,
                                                topLevelItem.name,
                                            );
                                        }}
                                        href={topLevelItem.url}>{topLevelItem.name}</a
                                    >
                                {:else if topLevelItem.type === MENU_TYPES.SUBMENU}
                                    <div class="submenu-parent-row">
                                        <div class="toplevel-item-name-wrapper">
                                            {#if topLevelItem.icon}
                                                <Icon icon={topLevelItem.icon} />
                                            {/if}
                                            <span class="toplevel-item-name">{topLevelItem.name}</span>
                                        </div>
                                        {#if selectedMenuItemString === `${menuIndex}-${sectionIndex}`}
                                            <Icon icon={faChevronUp} />
                                        {:else}
                                            <Icon icon={faChevronDown} />
                                        {/if}
                                    </div>
                                    {#if selectedMenuItemString === `${menuIndex}-${sectionIndex}`}
                                        <div transition:slide|global class="submenu-section">
                                            <ul class="submenu-list">
                                                {#each topLevelItem.children as item}
                                                    {#if item.type === MENU_TYPES.SUBMENU_SECTION}
                                                        <li
                                                            class="submenu-section-title"
                                                            style="border-bottom:1px solid white"
                                                        >
                                                            {item.name}
                                                        </li>
                                                        {#each item.children as submenuSectionItem}
                                                            <li>
                                                                <a
                                                                    on:click={() => {
                                                                        closeMenu();
                                                                        trackNavigationClick(
                                                                            trackNavigationClickTypes.MOBILE_MENU_CLICK,
                                                                            submenuSectionItem.name,
                                                                        );
                                                                    }}
                                                                    href={submenuSectionItem.url}
                                                                >
                                                                    {submenuSectionItem.name}
                                                                </a>
                                                            </li>
                                                        {/each}
                                                    {:else if item.type === MENU_TYPES.EMPTY_SPACE}
                                                        <li on:click={(e) => e.stopPropagation()}>&nbsp;</li>
                                                    {:else if item.type === MENU_TYPES.COLOR_LINK}
                                                        <li>
                                                            <div class="color-wrapper">
                                                                <a
                                                                    href={item.url}
                                                                    on:click={() => {
                                                                        closeMenu();
                                                                        trackNavigationClick(
                                                                            trackNavigationClickTypes.MOBILE_MENU_CLICK,
                                                                            item.name,
                                                                        );
                                                                    }}
                                                                >
                                                                    <div
                                                                        class="color"
                                                                        style="background: {item.color}"
                                                                    />
                                                                    <div>{item.name}</div>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    {:else}
                                                        <li>
                                                            <a
                                                                on:click={() => {
                                                                    closeMenu();
                                                                    trackNavigationClick(
                                                                        trackNavigationClickTypes.MOBILE_MENU_CLICK,
                                                                        item.name,
                                                                    );
                                                                }}
                                                                href={item.url}>{item.name}</a
                                                            >
                                                        </li>
                                                    {/if}
                                                {/each}
                                            </ul>
                                        </div>
                                    {/if}
                                {:else}{topLevelItem.name}{/if}
                            </div>
                        </li>
                    {/each}
                {/each}
            </ul>
        </nav>
        <div class="contact_info">
            <div>
                <div class="flex mb-4">
                    <div class="my-auto mr-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-5 h-5"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                            />
                        </svg>
                    </div>
                    <div><a href="tel:+4633123050">033 - 12 30 50</a></div>
                </div>
                <div class="flex">
                    <div class="my-auto mr-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-6 h-6"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                            />
                        </svg>
                    </div>
                    <div>
                        <a href="mailto:info@nylandersmattor.se">info@nylandersmattor.se</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</aside>

<style>
    a,
    a:hover {
        color: white;
    }
    aside {
        left: -100%;
        transition: left 0.3s ease-in-out;
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(17, 17, 17, 0.95);
        background: linear-gradient(
            270deg,
            rgba(17, 17, 17, 0.95) 0%,
            rgba(43, 43, 43, 0.95) 50%,
            rgba(17, 17, 17, 0.95) 100%
        );
        z-index: 11;
        overflow-y: auto;
    }

    .scroller {
        z-index: 11;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /* The main point: */
        overflow-y: auto;
        /* Optional but highly reccomended: enables momentum scrolling on iOS */
        -webkit-overflow-scrolling: touch;
    }

    .contact_info {
        margin: 25px 12px;
        color: white;
        font-size: 20px;
        padding: 20px;
    }

    .contact_info a {
        color: white;
    }

    .open {
        left: 0;
    }
    nav {
        font-size: 1.2rem;
        margin-left: 12px;
        margin-right: 12px;
        padding-top: 60px;
        text-transform: uppercase;
        line-height: 1.4em;
        color: #fafafa;
        font-weight: normal;
    }
    nav ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }
    nav > ul > li {
        padding: 6px 0px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    }
    .submenu-parent-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 44px;
    }
    .toplevel-item-name-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .toplevel-item-name {
        margin-left: 8px;
    }
    nav ul.submenu-list {
        margin-left: 22px;
        font-size: 1.2rem;
        font-weight: 400;
        text-transform: none;
    }
    ul.submenu-list > li {
        padding: 5px 0;
    }
    ul.submenu-list a {
        display: block;
    }
    .submenu-section-title {
        font-size: 1.5rem;
        font-weight: 800;
    }
    ul.submenu-list .color-wrapper a {
        display: flex;
        align-items: center;
    }
    .color {
        width: 40px;
        height: 40px;
        border-radius: 3px;
        border: 1px solid #aaa;
        margin-right: 8px;
    }
</style>
